module.exports = __webpack_public_path__ + "img/01.970d2b8e.png";